<template>
  <footer id="footer">
    <a target="_blank" href="//sketchbook.r42.ca">This site is part of the <b>r42 Sketchbook</b></a>
    <span>Copyright © 2019 - r42 communication</span>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="stylus" scoped>
#footer {
    padding: 40px 0 25px
    font-size: 14px
    line-height: 24px
    margin: 10px auto 0;
    text-align: center;
    background-color: #f7f4f2;

    & span {
        display: block
        font-size: 12px
    }

  & a {
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #666;
    margin: 0;
    padding: 5px;
    opacity: 0.5;
    text-decoration: none;
  }
}
</style>

